import { Button, Typography } from "antd";
import Link from "next/link";
import { useEffect } from "react";

const { Paragraph } = Typography;

const Error500 = ({ message = "O-o-oh! Something broke." }) => {
  const mouseCapture = () => {
    document
      .getElementById("error-500")
      ?.addEventListener("mousemove", (event: any) => {
        let e: any = document.getElementById("eye1");
        let e2: any = document.getElementById("eye2");
        let x = e?.offsetLeft + e?.offsetWidth / 2;
        let y = e?.offsetTop + e?.offsetHeight / 2;
        let rad = Math.atan2(event.pageX - x, event.pageY - y);
        let rot = rad * (180 / Math.PI) * -1 + 180;
        e.style.transform = "rotate(" + rot + "deg)";
        e2.style.transform = "rotate(" + rot + "deg)";
      });
  };

  useEffect(() => mouseCapture(), []);

  return (
    <div className="error-500" id="error-500">
      <div>
        <div className="num-container">
          <span className="error-num">5</span>
          <div className="eye" id="eye1"></div>
          <div className="eye" id="eye2"></div>
        </div>
        <Paragraph id="errorText">{message}</Paragraph>
        <Link href={"/"}>
          <Button size="large" className="btn-dark">
            Go Back
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Error500;
